import {option, Option} from "ts-option";
import {JobTypeApiDto, JobTypePbUpdateApiDto} from "../../api/model/rest";

export const GAS_SAFETY_CERTIFICATE_ID = "9200607c-9e9f-40ee-b44e-d6ad8bc37de7";

export default class JobType {
	constructor(public readonly id: string,
		public readonly name: string,
		public readonly activityTemplateId: Option<string>,
		public readonly labourOnly: boolean,
		public readonly fee: number,
		public readonly repairWithParts: boolean,
		public readonly active: boolean,
		public readonly utilityId?: string) {}

	static fromJson(json: JobTypeApiDto): JobType {
		return new JobType(json.id, json.name, option(json.activityTemplateId), json.labourOnly, json.fee, json.repairWithParts,
			json.active, json.utilityId != null ? json.utilityId : undefined)
	}

	toJson(): JobTypeApiDto {
		return {
			id: this.id,
			name: this.name,
			activityTemplateId: this.activityTemplateId.orNull,
			labourOnly: this.labourOnly,
			fee: this.fee,
			repairWithParts: this.repairWithParts,
			active: this.active,
			utilityId: this.utilityId
		}
	}

	toPbUpdateJson(): JobTypePbUpdateApiDto {
		return {
			id: this.id,
			active: this.active,
			fee: this.fee,
			utilityId: this.utilityId != null ? this.utilityId : undefined
		}
	}

	copy({active = this.active, fee = this.fee}: {active?: boolean, fee?: number}) {
		return new JobType(this.id, this.name, this.activityTemplateId, this.labourOnly, fee, this.repairWithParts, active, this.utilityId);
	}

	withUtility(utilityId: string | undefined): JobType {
		return new JobType(this.id, this.name, this.activityTemplateId, this.labourOnly, this.fee, this.repairWithParts, this.active, utilityId);
	}
}
